import { render } from "./g-tab-control.vue?vue&type=template&id=3965d0d6&ts=true"
import script from "./g-tab-control.vue?vue&type=script&lang=tsx"
export * from "./g-tab-control.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__